module.exports = __webpack_public_path__ + "static/media/trout.91c12c11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Heathbot/trout.jpg
// module id = 189
// module chunks = 0